import { FC } from 'react'
import { IWaitingListRecord } from '../survey/SurveyModel/types/nodeTypes';
import dayjs from 'dayjs';
import Telephone from '../../assets/Telephone';

type UserDetailsProps = {
    waitingListRecord: IWaitingListRecord | null;
    isLoading: boolean;
}

const UserDetails: FC<UserDetailsProps> = ({ waitingListRecord }) => {
    return (
        <div className="user-details flex flex-row ">
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key">CHI:</div>
                <div className="user-item-value whitespace-nowrap">
                    {waitingListRecord?.chiNumber || '--'}
                </div>
            </div>
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key">DOB:</div>
                <div className="user-item-value whitespace-nowrap">
                    {waitingListRecord?.dob ? dayjs(waitingListRecord.dob).format('DD/MM/YY') : '--'}
                </div>
            </div>
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key">Age:</div>
                <div className="user-item-value whitespace-nowrap">{waitingListRecord?.age || '--'}</div>
            </div>
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key">Sex:</div>
                <div className="user-item-value whitespace-nowrap">{waitingListRecord?.sex || '--'}</div>
            </div>
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key"><Telephone className="inline mr-1" /></div>
                <div className="user-item-value whitespace-nowrap">
                    {waitingListRecord?.mobileNumber || '--'}
                </div>
            </div>
            <div className="divider"></div>
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key">Speciality:</div>
                <div className="user-item-value whitespace-nowrap">
                    {waitingListRecord?.speciality || '--'}
                </div>
            </div>
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key">Anae:</div>
                <div className="user-item-value whitespace-nowrap">
                    {waitingListRecord?.anaestheticType || '--'}
                </div>
            </div>
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key">IP/DSU:</div>
                <div className="user-item-value whitespace-nowrap">
                    {waitingListRecord?.intendedManagementReferenceCode || '--'}
                </div>
            </div>
            <div className="user-item flex lg:flex-row">
                <div className="user-item-key">Hospital:</div>
                <div className="user-item-value whitespace-nowrap">
                    {waitingListRecord?.hospitalName || '--'}
                </div>
            </div>
            <div className="user-item flex flex-row">
                <div className="user-item-key">Surgeon:</div>
                <div className="user-item-value whitespace-nowrap">
                    {waitingListRecord?.surgeon || '--'}
                </div>
            </div>
        </div>
    )
}

export default UserDetails
